import { render } from "./ListeRegion.vue?vue&type=template&id=29a4fc42&ts=true"
import script from "./ListeRegion.vue?vue&type=script&lang=ts"
export * from "./ListeRegion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__